/** An enumeration of `event.key` names, so you don't have to keep looking them up online. */
// (clewis): Please add additional names as you need them, ordered alphabetically by enum key.

export enum KeyNames {
  ALT = "Alt",
  ARROW_DOWN = "ArrowDown",
  ARROW_LEFT = "ArrowLeft",
  ARROW_RIGHT = "ArrowRight",
  ARROW_UP = "ArrowUp",
  BACKSPACE = "Backspace",
  COMMA = ",",
  CONTROL = "Control",
  DELETE = "Delete",
  ENTER = "Enter",
  ESCAPE = "Escape",
  META = "Meta",
  MINUS = "-",
  SHIFT = "Shift",
  SPACE = " ",
  TAB = "Tab",
}
